import React, { FC, useState } from 'react';
import { Checkbox, Input, Dropdown } from 'semantic-ui-react';
import { LmntVoiceSettings, VOICE_MODELS, VOICE_PROVIDERS } from '../../../../core/api/VoiceConfig';
import { SettingsContainer, SettingRow, Label, SliderContainer, ValueDisplay } from './styles';

export interface Props {
  settings: LmntVoiceSettings;
  onChange: (settings: LmntVoiceSettings) => void;
}

export const LmntSettings: FC<Props> = ({ settings, onChange }) => {
  console.log('LmntVoiceSettings render with settings:', settings);
  const [customModelId, setCustomModelId] = useState('');

  const handleChange = (key: keyof LmntVoiceSettings | keyof LmntVoiceSettings['options'], value: any) => {
    console.log('handleChange called with:', { key, value });
     if (key === 'model') {
      const newSettings = {
        ...settings,
        model: value
      };
      console.log('Updating model with settings:', newSettings);
      onChange(newSettings);
    } else {
      const newSettings = {
        ...settings,
        options: {
          ...settings.options,
          [key]: value
        }
      };
      console.log('Updating options with settings:', newSettings);
      onChange(newSettings);
    }
  };

  const handleModelChange = (value: string) => {
    console.log('handleModelChange called with:', value);
    if (value === 'custom') {
      handleChange('model', customModelId || '');
    } else {
      handleChange('model', value);
      setCustomModelId('');
    }
  };

  const handleCustomModelChange = (value: string) => {
    console.log('handleCustomModelChange called with:', value);
    setCustomModelId(value);
    handleChange('model', value);
  };

  const modelOptions = VOICE_MODELS[VOICE_PROVIDERS.LMNT].map(model => ({
    key: model.id,
    value: model.id,
    text: model.name
  }));

  const selectedModel = VOICE_MODELS[VOICE_PROVIDERS.LMNT].find(m => m.id === settings.model)
    ? settings.model
    : 'custom';
  
  console.log('Current state:', {
    selectedModel,
    customModelId,
    modelOptions,
    settings
  });

  return (
    <SettingsContainer>
      <SettingRow>
        <Label>Model</Label>
        <div style={{ display: 'flex', gap: '8px' }}>
          <div style={{ flex: 1 }}>
            <Dropdown
              selection
              fluid
              options={modelOptions}
              value={selectedModel}
              onChange={(_, { value }) => handleModelChange(value as string)}
            />
          </div>
          {selectedModel === 'custom' && (
            <div style={{ flex: 2 }}>
              <Input 
                fluid
                placeholder="Enter custom model ID"
                value={customModelId || settings.model}
                onChange={(e) => handleCustomModelChange(e.target.value)}
              />
            </div>
          )}
        </div>
      </SettingRow>

      <SettingRow>
        <SliderContainer>
          <Label>Temperature</Label>
          <Input 
            type="range"
            min={0}
            max={10}
            step={0.1}
            value={settings.options.temperature}
            onChange={(e) => handleChange('temperature', parseFloat(e.target.value))}
          />
          <ValueDisplay>{settings.options.temperature?.toFixed(1)}</ValueDisplay>
        </SliderContainer>
      </SettingRow>

      <SettingRow>
        <SliderContainer>
          <Label>Top P</Label>
          <Input
            type="range"
            min={0}
            max={1}
            step={0.1}
            value={settings.options.top_p}
            onChange={(e) => handleChange('top_p', parseFloat(e.target.value))}
          />
          <ValueDisplay>{settings.options.top_p?.toFixed(1)}</ValueDisplay>
        </SliderContainer>
      </SettingRow>
    </SettingsContainer>
  );
}; 
